<template>
  <div class="page-index">
    <div class="nav pc-img" :class="sticky ? 'sticky' : ''">
      <div class="header flex flex-cross-center">
        <div class="v2power_logo">
          <img class="logo_img" src="../assets/img/v2power_logo.svg" alt="" />
        </div>
        <div class="nav_list">
          <span
            :data-id="item.id"
            class="nav_name"
            :class="{ active: item.id == selectedNav }"
            v-for="item in navList"
            :key="item.id"
            @click="selectNav(item)"
          >
            <a :href="'#' + item.id">{{ item.name }}</a></span
          >
        </div>
        <div class="contact_us">
          <a
            :href="v2powerAppUrl"
            class="go-charging-simulation cp login-btn"
            target="_blank"
            >LOGIN</a
          >
        </div>
      </div>
    </div>
    <div
      class="v2power_logo mobile-img flex flex-cross-center flex-main-justify"
    >
      <img class="logo_img" src="../assets/img/v2power_logo.svg" alt="" />
      <div class="contact_us">
        <a
          :href="v2powerAppUrl"
          class="go-charging-simulation cp login-btn"
          target="_blank"
          >LOGIN</a
        >
      </div>
    </div>
    <div id="home">
      <div class="home_body">
        <el-carousel
          indicator-position="outside"
          :autoplay="true"
          class="home-banner-carousel"
        >
          <el-carousel-item>
            <img
              src="../assets/img/pc/home_banner_1.png"
              class="pc-img"
              alt=""
            />
            <img
              src="../assets/img/mobile/home_banner_1.png"
              class="mobile-img"
              alt=""
            />
            <div class="home_content">
              <div class="content_title">
                <h5>Leader in the New Energy Era</h5>
                <h5>Photovoltaic, EnergyStorage, and charging Solutions</h5>
              </div>
              <div class="content_info">
                Focusing on integrated energy solutions
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="../assets/img/pc/home_banner_2.png"
              class="pc-img"
              alt=""
            />
            <img
              src="../assets/img/mobile/home_banner_2.png"
              class="mobile-img"
              alt=""
            />
            <div class="home_content">
              <div class="content_title">
                <h5>Flexible adaptation to multiple scenarios</h5>
                <h5>making energy more efficient and greener</h5>
              </div>
              <div class="content_info">
                Suitable for diverse scenarios such as power stations,
                commercial buildings, industrial parks, and charging stations
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="../assets/img/pc/home_banner_3.png"
              class="pc-img"
              alt=""
            />
            <img
              src="../assets/img/mobile/home_banner_3.png"
              class="mobile-img"
              alt=""
            />
            <div class="home_content">
              <div class="content_title">
                <h5>Technology-driven energy innovation</h5>
              </div>
              <div class="content_info">
                One-stop integration'from hardware to software
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="../assets/img/pc/home_banner_4.png"
              class="pc-img"
              alt=""
            />
            <img
              src="../assets/img/mobile/home_banner_4.png"
              class="mobile-img"
              alt=""
            />
            <div class="home_content">
              <div class="content_title">
                <h5>Intelligent operations and Maintenance,</h5>
                <h5>Building the Future of Energy Together</h5>
              </div>
              <div class="content_info">
                Asset operation and maintenance, real-time data monitoring
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="bg-box"></div>
        <div class="line-box"></div>
      </div>
    </div>
    <div id="About" class="about-side side-public-style">
      <h5>About us</h5>
      <div class="about-side-content">
        <p>
          Welcome to v2power, the forefront innovators in the green energy
          movement. Specializing in cutting-edge EV charging and advanced solar
          energy solutions, our mission is to revolutionize energy distribution.
          We are dedicated to empowering you with the means to dramatically
          reduce energy expenses and to build a robust, super-fast charging
          infrastructure.
        </p>
        <p class="tip">
          Our commitment is straightforward and unwavering: We are here to guide
          and support you in the transitiontowards sustainable energy, helping
          you to establish an efficient and cost-effective super charging
          networkJoin us in paving the way for a greener, more sustainable
          future.
        </p>
      </div>
    </div>
    <div id="Products" class="product-side side-public-style">
      <h5>Products</h5>
      <div class="product-side-content">
        <div class="pc-img">
          <div class="flex flex-main-justify product-nav">
            <div
              v-for="(item, index) in products"
              :key="item.id"
              class="product-nav-one flex flex-cross-center"
              :class="{ active: selectedProduct == item.id }"
              @click="selectProduct(item, index)"
            >
              <img
                :src="selectedProduct == item.id ? item.activeUrl : item.url"
                alt=""
              />
              <p>{{ item.name }}</p>
            </div>
          </div>
        </div>
        <el-carousel
          indicator-position="outside"
          ref="carousel"
          @change="selectCarouselProduct"
          :autoplay="carouselAutoplay"
          class="product-carousel"
        >
          <el-carousel-item>
            <img src="../assets/img/pc/Eagle.jpg" alt="" />
            <div class="text-content">
              <h6>
                Eagle Series – Medium to Large-Scale PV+Storage+Charging
                Solution
              </h6>
              <p>
                <i class="tvc"></i>Modular design for better adaptability to
                each site
              </p>
              <p>
                <i class="tvc"></i>Diversified revenue streams, enabling users
                to benefit from energy savings, ancillary service revenues, and
                EV charging income
              </p>
              <p>
                <i class="tvc"></i>Integrated hardware and software design for
                optimized system configuration
              </p>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../assets/img/pc/Swift.jpg" alt="" />
            <div class="text-content">
              <h6>
                Swift Series – Small-Scale PV+ Storage+High-Power Charging
                Solution
              </h6>
              <p>
                <i class="tvc"></i>Tailored for limited-grid sites to cut
                connection costs
              </p>
              <p>
                <i class="tvc"></i>Cheaper imports enable competitive EV
                charging rates
              </p>
              <p>
                <i class="tvc"></i>Battery dispatch adds new revenue from
                peak-time energy sales
              </p>
              <p><i class="tvc"></i>LEGO-type structure, easy installation</p>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../assets/img/pc/EnerArk.jpg" alt="" />
            <div class="text-content">
              <h6>
                Energy Storage Series – PV+Storage Solutions for C&I
              </h6>
              <p>
                <i class="tvc"></i>High Energy Density in Integrated All-in-One
                Design
              </p>
              <p><i class="tvc"></i>Maximizing Solar Self-Consumption</p>
              <p>
                <i class="tvc"></i>Peak shaving & grid export potential with AI
                based EMS
              </p>
              <p>
                <i class="tvc"></i>Maximizing Solar Self-Consumption while
                reducing grid dependency
              </p>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../assets/img/pc/AC.jpg" alt="" />
            <div class="text-content">
              <h6>
                EV Charger
              </h6>
              <p><i class="tvc"></i>Multiple charging mode</p>
              <p><i class="tvc"></i>Outstanding safety performance</p>
              <p><i class="tvc"></i>Dedicated smart charging APP</p>
              <p><i class="tvc"></i>Dynamic load balancing</p>
              <p><i class="tvc"></i>Multi-scenario application mode</p>
              <p><i class="tvc"></i>Superior customer service</p>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../assets/img/pc/Home BESS.jpg" alt="" />
            <div class="text-content">
              <h6>
                Home BESS
              </h6>
              <p>
                <i class="tvc"></i>The first home energy storage battery with
                fire extinguisher integrated
              </p>
              <p>
                <i class="tvc"></i>-20'C cold climate outdoor&indoor
                installation
              </p>
              <p>
                <i class="tvc"></i>Electric vehicle grade battery module design
              </p>
              <p><i class="tvc"></i>Stackable up-to 4 batteries</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div id="Platform" class="softwares-side side-public-style">
      <h5>Platform</h5>
      <div class="software-one flex-cross-center Platform">
        <div class="img-box flex flex-cross-center flex-main-center left">
          <img src="../assets/img/pc/SP5.png" alt="" />
        </div>
        <div class="p-l">
          <h6 class="title">ScalesPower – Ultra-fast Charging Mode</h6>
          <p>
            ScalesPower – Ultra-fast Charging Mode showcase the site' s
            operational status and revenue performance for site owners and
            investors. It enables site owners to switch between Ultra-fast
            Charging, Energy-saving, and Ancillary Service modes.
          </p>
          <p class="special-one special-first">
            <i class="tvc"></i>Three operation modes to earn more revenues
          </p>
          <p class="special-one">
            <i class="tvc"></i>Making Scheduling Plan and Execution
          </p>
        </div>
      </div>
      <div class="software-one flex-cross-center cpo">
        <div
          class="img-box flex flex-cross-center flex-main-center right mobile-img"
        >
          <img src="../assets/img/pc/CPO.png" alt="" />
        </div>
        <div class="p-r">
          <h6 class="title">CPO(“Charge Point Operator”)Platform</h6>
          <p>
            CPO platform offers a wide range of functionalities for EV charging
            operations. It streamlines customer management, offers a flexible
            pricing model, includes a user-friendly mobile app, and features
            AI-driven business analytics dashboards for powerful insights.
          </p>
          <p class="special-one special-first">
            <i class="tvc"></i>Charging Related Data Showcase and Analysis
          </p>
          <div class="public-go-btn-box">
            <a
              class="public-go-btn cp"
              target="_blank"
              href="https://ocpp.v2power.io/partner/pages/cms/user/email/signin"
              >Login</a
            >
          </div>
        </div>
        <div
          class="img-box flex flex-cross-center flex-main-center right pc-img"
        >
          <img src="../assets/img/pc/CPO.png" alt="" />
        </div>
      </div>
      <div class="software-one flex-cross-center Platform">
        <div class="img-box flex flex-cross-center flex-main-center left">
          <img src="../assets/img/pc/SP3.png" alt="" />
        </div>
        <div class="p-l">
          <h6 class="title">ScalesPower – Energy Saving Mode</h6>
          <p>
            ScalesPower — Energy saving mode is an Platform management platform
            designed for commercial and industrial solar energy storage
            systPlatform.
          </p>
          <p class="special-one special-first">
            <i class="tvc"></i>AI based forecast & scheduling algorithms
          </p>
          <p class="special-one">
            <i class="tvc"></i>Energy Saving Mode Highlight
          </p>
          <div class="public-go-btn-box">
            <a
              class="public-go-btn cp"
              target="_blank"
              href="https://www.xrenewable.cn:8683/login"
              >Login</a
            >
          </div>
        </div>
      </div>
      <div class="software-one flex-cross-center cpo">
        <div
          class="img-box flex flex-cross-center flex-main-center right mobile-img"
        >
          <img src="../assets/img/pc/O&M.png" alt="" />
        </div>
        <div class="p-r">
          <h6 class="title">O&M</h6>
          <p>
            V2power O&M system provides site owners with asset operation
            monitoring and immediately issues alerts in case of a fault, to
            ensure the smooth operation of the site.
          </p>
          <p class="special-one special-first">
            <i class="tvc"></i>Real-time Monitoring
          </p>
          <p class="special-one"><i class="tvc"></i>Timely Feedback</p>
          <div class="public-go-btn-box">
            <a
              class="public-go-btn cp"
              target="_blank"
              href="https://xrenewable.cn:8690/login"
              >Login</a
            >
          </div>
        </div>
        <div
          class="img-box flex flex-cross-center flex-main-center right pc-img"
        >
          <img src="../assets/img/pc/O&M.png" alt="" />
        </div>
      </div>
    </div>
    <div id="Partnership" class="partnerships-side side-public-style">
      <div class="partners">
        <h5>Our partners</h5>
        <p>Our eco-system partner in Europe</p>
        <div class="company-logo-list flex">
          <div class="img-box">
            <img src="../assets/img/pc/Partners 1.png" alt="" />
          </div>
          <div class="img-box">
            <img src="../assets/img/pc/Partners 2.png" alt="" />
          </div>
          <div class="img-box">
            <img src="../assets/img/pc/Partners 3.png" alt="" />
          </div>
          <div class="img-box">
            <img src="../assets/img/pc/Partners 4.png" alt="" />
          </div>
          <div class="img-box octopusenergy">
            <img src="../assets/img/pc/Partners 5.png" alt="" />
          </div>
          <div class="img-box">
            <img src="../assets/img/pc/Partners 6.png" alt="" />
          </div>
          <div class="img-box">
            <img src="../assets/img/pc/Partners 7.png" alt="" />
          </div>
          <div class="img-box">
            <img src="../assets/img/pc/Partners 8.png" alt="" />
          </div>
          <div class="img-box">
            <img src="../assets/img/pc/Partners 9.png" alt="" />
          </div>
          <div class="img-box strip">
            <img src="../assets/img/pc/Partners 10.png" alt="" />
          </div>
          <div class="img-box">
            <img src="../assets/img/pc/Partners 11.png" alt="" />
          </div>
          <div class="img-box mdl">
            <img src="../assets/img/pc/Partners 12.png" alt="" />
          </div>
        </div>
      </div>
      <div class="finding-box">
        <h5>We are finding</h5>
        <p class="introduce">
          In partnership with local experts, our team is ready to assist you in
          procuring the right equipment and developing cost-effective virtual
          power plants, propelling us towards a net-zero society.
        </p>
        <div class="list">
          <div class="developer">
            <img src="../assets/img/pc/Developer.png" class="pc-img" alt="" />
            <p class="title">Developer</p>
            <p>
              We can provide high-quality storage,PV and chargings solutions
              forproject developers, along with theassociated software platform.
            </p>
          </div>
          <div class="landowner">
            <img src="../assets/img/pc/Landowner.png" class="pc-img" alt="" />
            <p class="title">Landowner</p>
            <p>
              We can offer landowners businessplan as well as the
              comprehensivestorage,PV and chargings solutionsalong with
              subsequent assetmanagement and operationalservices software.
            </p>
          </div>
          <div class="installer">
            <img src="../assets/img/pc/Installer.png" class="pc-img" alt="" />
            <p class="title">Installer</p>
            <p>
              We can supply installers with a largequantity of high-quality
              storage, PVand charging solutions.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div id="Cases" class="cases-side side-public-style">
      <h5>Case studies</h5>
      <div class="case-list">
        <div class="case-one malta-system">
          <img class="pc-img" src="../assets/img/pc/Malta.png" alt="" />
          <img class="mobile-img" src="../assets/img/pc/Car park.png" alt="" />
          <p>Eagle Series - Located in Malta</p>
        </div>
        <div class="ireland-system-box">
          <div class="case-one">
            <img class="pc-img" src="../assets/img/pc/Ireland.png" alt="" />
            <img class="mobile-img" src="../assets/img/pc/Ireland.png" alt="" />
            <p>Eagle Series - Located in Ireland</p>
          </div>
          <div class="case-one">
            <img class="pc-img" src="../assets/img/pc/Farm-U.png" alt="" />
            <img class="mobile-img" src="../assets/img/pc/Farm-U.png" alt="" />
            <p>Farm U - Located in UK</p>
          </div>
          <div class="case-one m-t">
            <img class="pc-img" src="../assets/img/pc/Farm R.png" alt="" />
            <img class="mobile-img" src="../assets/img/pc/Farm R.png" alt="" />
            <p>Farm R - Located in UK</p>
          </div>
          <div class="case-one m-t">
            <img class="pc-img" src="../assets/img/pc/Farm B.png" alt="" />
            <img class="mobile-img" src="../assets/img/pc/Farm B.png" alt="" />
            <p>Farm B - Located in UK</p>
          </div>
        </div>
      </div>
    </div>
    <div id="contact" class="cases-side side-public-style">
      <div class="about">
        <div class="all_margin contact_body">
          <div class="contact_word">
            <img
              src="../assets/img/logo_yellow.png"
              class="logo pc-img"
              alt=""
            />
            <div class="word_top contact_tip">
              If you're interested in starting a project or obtaining a quote
              for one of our services, please send an email to
              info@v2power.io. One of our exceptional team members will
              promptly contact you to discuss your requirements.
            </div>
            <div class="word_margin word_top pc-img">
              <h6>CONTACT US</h6>
              <p>E-mail: info@v2power.io</p>
              <p>Address UK: 20-22 Wenlock Road, London, England, N1 7GU</p>
            </div>
          </div>
          <div class="send_msg">
            <div class="msg_title">Contact information</div>
            <el-form :model="contactInfo" ref="contactInfo">
              <el-form-item
                prop="name"
                label=""
                :rules="[
                  {
                    required: true,
                    message: 'Name cannot be empty',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  clearable
                  class="input_info"
                  :maxlength="50"
                  v-model="contactInfo.name"
                  placeholder="Your name"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="email"
                label=""
                :rules="[
                  {
                    required: true,
                    message: 'Email address cannot be empty',
                    trigger: 'blur'
                  },
                  {
                    type: 'email',
                    message: 'Please enter the correct email address',
                    trigger: ['blur', 'change']
                  }
                ]"
              >
                <el-input
                  :maxlength="50"
                  clearable
                  class="input_info"
                  v-model="contactInfo.email"
                  placeholder="Your email"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="phone"
                label=""
                :rules="[
                  {
                    required: true,
                    message: 'Mobile phone number cannot be empty',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  clearable
                  :maxlength="20"
                  class="input_info"
                  v-model="contactInfo.phone"
                  @input="handleInput"
                  placeholder="Your phone"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="message"
                label=""
                :rules="[
                  {
                    required: true,
                    message: 'Information cannot be empty',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  type="textarea"
                  :maxlength="256"
                  :autosize="{ minRows: 2, maxRows: 3 }"
                  class="input_info"
                  v-model="contactInfo.message"
                  placeholder="Your message"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <div class="msg_btn" @click="submitForm('contactInfo')">
                  Send message
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="word_margin word_top mobile-img">
            <h6>CONTACT US</h6>
            <p>E-mail: info@v2power.io</p>
            <p>Address UK: 20-22 Wenlock Road, London, England, N1 7GU</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="btnFlag" class="backTop" @click="backTop">
      <img src="../assets/img/backtop.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      carouselAutoplay: true,
      selectedProduct: 0,
      products: [
        {
          id: 0,
          name: "Eagle Series Charging system",
          url: require("../assets/img/pc/icon/Eagle 1.svg"),
          activeUrl: require("../assets/img/pc/icon/Eagle 2.svg")
        },
        {
          id: 1,
          name: "Swift Series DC Charging System",
          url: require("../assets/img/pc/icon/Swift 1.svg"),
          activeUrl: require("../assets/img/pc/icon/Swift 2.svg")
        },
        {
          id: 2,
          name: "Hybrid EnerArk Series - All-in-One PV+BESS",
          url: require("../assets/img/pc/icon/EnerArk 1.svg"),
          activeUrl: require("../assets/img/pc/icon/EnerArk 2.svg")
        },
        {
          id: 3,
          name: "AC Charger",
          url: require("../assets/img/pc/icon/AC charging 1.svg"),
          activeUrl: require("../assets/img/pc/icon/AC charging 2.svg")
        },
        {
          id: 4,
          name: "Home BESS",
          url: require("../assets/img/pc/icon/Home BESS 1.svg"),
          activeUrl: require("../assets/img/pc/icon/Home BESS 2.svg")
        }
      ],
      sticky: false,
      btnFlag: false,
      isMobile: false,
      selectedNav: "",
      navList: [
        { id: "About", name: "About us" },
        { id: "Products", name: "Products" },
        { id: "Platform", name: "Platform" },
        { id: "Partnership", name: "Partnership" },
        { id: "Cases", name: "Case studies" },
        { id: "contact", name: "Contact Us" }
      ],
      contactInfo: {
        name: "",
        email: "",
        phone: "",
        massage: ""
      },
      scrollTop: 0,
      navItems: [],
      sections: [],
      currentSectionId: "",
      sectionTop: ""
    };
  },
  computed: {
    v2powerAppUrl() {
      return (
        process.env.VUE_APP_V2POWER_APP_URL || "http://localhost:5173"
      );
    }
  },
  methods: {
    goDemo() {
      this.PUSH({
        name: "demo"
      });
    },
    selectCarouselProduct(index) {
      this.selectedProduct = index;
    },
    selectProduct(item, index) {
      this.selectedProduct = item.id;
      this.$refs.carousel.setActiveItem(index);
      this.carouselAutoplay = false;
    },
    selectNav(item) {
      const navItems = document.querySelectorAll(".nav_name");
      // 更新导航样式
      navItems.forEach(navItem => {
        console.log(navItem.getAttribute("id"), "hash");
        navItem.classList.remove("active");
      });
      this.selectedNav = item.id;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // alert("submit!");
          const qs = require("qs");
          let info = {
            name: this.contactInfo.name,
            email: this.contactInfo.email,
            phone: this.contactInfo.phone,
            message: this.contactInfo.message
          };
          // let info = new FormData();
          // info.append("name", this.contactInfo.name);
          // info.append("email", this.contactInfo.email);
          // info.append("phone", this.contactInfo.phone);
          // info.append("message", this.contactInfo.message);
          this.$http
            .post("/PHPMailer/sendMail.php", qs.stringify(info), {
              "content-type": "application/x-www-form-urlencoded;charset=UTF-8;"
              // "content-type": "application/json;charset=UTF-8;"
            })
            .then(res => {
              console.log(res, "res");
              this.$message({
                message: "Thank you for your message",
                type: "success"
              });
              this.contactInfo.name = "";
              this.contactInfo.email = "";
              this.contactInfo.phone = "";
              this.contactInfo.message = "";
            })
            .catch(res => {
              console.log(res, "error submit!!");
              this.$message.error("Sorry, upload failed");
            });
        } else {
          return false;
        }
      });
    },
    handleInput(value) {
      // 只允许输入"+"、"-"、正整数和0
      let reg = /^[+-]?\d+$/;
      if (!reg.test(value)) {
        this.$nextTick(() => {
          this.contactInfo.phone = value.replace(/[^-+\d]/g, "");
        });
      }
    },
    sendMsg() {
      console.log(this.contactInfo.name, "name");
      console.log(this.contactInfo.email, "email");
      console.log(this.contactInfo.phone, "phone");
      console.log(this.contactInfo.massage, "massage");
    },
    backTop() {
      const that = this;
      const timer = setInterval(() => {
        const isPeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + isPeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    scrollToTop() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.sticky = this.scrollTop > 0;
      this.currentId = "";
      this.sections.forEach((section, index) => {
        this.sectionTop = 0; // 预留导航栏高度
        if (index == this.sections.length - 1) {
          this.sectionTop = section.offsetTop - section.offsetHeight + 280;
        } else {
          this.sectionTop = section.offsetTop - 40;
        }
        if (window.scrollY >= this.sectionTop) {
          this.currentId = section.id;
        }
      });
      // 更新导航样式
      this.navItems.forEach(navItem => {
        // console.log(navItem.getAttribute("id"), "hash");
        navItem.classList.toggle(
          "active",
          navItem.dataset.id === this.currentId
        );
        if (navItem.dataset.id === this.currentId) {
          history.replaceState(null, document.title, "#" + this.currentId);
        }
      });
      // 为了计算距离顶部的高度，当高度大于300显示回顶部图标，小于300则隐藏
      if (this.scrollTop > 100) {
        this.btnFlag = true;
      } else {
        this.btnFlag = false;
        history.replaceState(null, document.title, window.location.pathname);
      }
    }
  },
  mounted() {
    this.navItems = document.querySelectorAll(".nav_name");
    this.sections = document.querySelectorAll(".side-public-style");
    window.addEventListener("scroll", this.scrollToTop, 400);
    // 在组件挂载后获取屏幕宽度并进行判断
    this.isMobile = window.innerWidth < 800;
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 800;
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  }
};
</script>

<style lang="scss">
$primary-color: #00a5df;
$dark-color: #080404;
.el-textarea__inner {
  resize: none;
}
p,
h4,
h5,
h6,
span,
a,
input,
.el-textarea__inner {
  font-family: Verdana;
}
.el-carousel {
  .el-carousel__indicators {
    li {
      &.is-active {
        button {
          background-color: $primary-color;
        }
      }
      button {
        width: 0.6rem;
        background-color: rgba(0, 165, 223, 0.2);
      }
    }
  }
}
.side-public-style {
  h5 {
    color: $primary-color;
    margin-bottom: 0.4rem;
    font-size: 0.4rem;
    font-weight: bold;
  }
  h6 {
    font-weight: bold;
    font-size: 0.24rem;
    color: $dark-color;
  }
}
.product-side {
  .text-content {
    p {
      position: relative;
      padding-left: 0.2rem;
      margin-top: 0.2rem;
      color: $dark-color;
      i {
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #00a5df;
        left: 0;
      }
    }
  }
}
.partnerships-side {
  padding-top: 0.8rem;
  .partners {
    background-image: url("../assets/img/pc/partner-bg.jpg");
    background-size: 100% 100%;
    h5 {
      text-align: center;
      color: #fff;
      padding-top: 0;
      margin-bottom: 0.2rem;
    }
    p {
      color: #fff;
      text-align: center;
      font-size: 0.18rem;
      margin-bottom: 0.4rem;
    }
    .company-logo-list {
      flex-wrap: wrap;
      .img-box {
        width: 16%;
        margin-right: 0.8%;
        margin-bottom: 0.1rem;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1.2rem;
        &.octopusenergy {
          background-color: #170048;
        }
        &.strip {
          background-color: #665bff;
        }
        &.mdl {
          background-color: #20293a;
        }
        img {
          max-width: 80%;
          max-height: 60%;
        }
      }
    }
  }
  .finding-box {
    .introduce {
      margin-bottom: 0.4rem;
    }
    .list {
      color: #fff;
      p {
        font-size: 0.2rem;
      }
      .title {
        font-weight: bold;
        font-size: 0.24rem;
        margin-bottom: 0.4rem;
      }
    }
  }
}
.cases-side {
  .case-one {
    position: relative;
    p {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 0.4rem;
      line-height: 0.4rem;
      background-color: $primary-color;
      color: #fff;
      padding-left: 0.1rem;
    }
    img {
      width: 100%;
    }
  }
}
.softwares-side {
  p {
    color: $dark-color;
  }
  .special-one {
    position: relative;
    padding-left: 0.2rem;
    margin-top: 0.2rem;
    i {
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #00a5df;
      left: 0;
    }
  }
}
.page-index {
  p {
    line-height: 0.3rem;
  }
}
.home_body {
  .home-banner-img {
    width: 100%;
    height: 100%;
  }
  .home_content {
    .content_title {
      color: #fff;
      font-weight: 600;
    }
    .content_info {
      font-size: 0.18rem;
      font-weight: 400;
      color: #fff;
      line-height: 0.28rem;
    }
  }
  .go-charging-simulation {
    background: $primary-color;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
    color: #fff;
  }
}
.about-side {
  .tip {
    font-weight: bold;
    margin-top: 0.4rem;
  }
}
#contact {
  background-color: rgba(8, 4, 4, 1);
  .word_margin {
    margin-top: 1rem;
    h6 {
      font-weight: bold;
      font-size: 0.28rem;
      margin-bottom: 0.2rem;
      color: #fff;
    }
  }
  .send_msg {
    background: #ffffff;
    border-radius: 0.28rem;
    line-height: 0.4rem;
    box-shadow: 0 8px 8px rgba(10, 16, 20, 0.24),
      0 0 0.08rem rgba(10, 16, 20, 0.12);
    .msg_btn {
      background: $dark-color;
      line-height: 0.6rem;
      border-radius: 0.08rem;
      color: #ffffff;
      text-align: center;
    }
  }
}
.backTop {
  width: 0.6rem;
  position: fixed;
  right: 5%;
}
.public-go-btn-box {
  margin-top: 0.2rem;
}
.public-go-btn {
  background: $primary-color;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
  color: #fff;
  padding: 0.1rem 0.2rem;
  border-radius: 0.06rem;
  margin-top: 0.2rem;
}
@media screen and (min-width: 912px) {
  .all_margin {
    margin: 0 10%;
  }
  .backTop {
    bottom: 0.8rem;
    cursor: pointer;
  }
  .about {
    width: 100%;
    max-width: 1920px;
  }
  .margin_left {
    margin-left: 10%;
  }
  .margin_right {
    margin-left: 0.6rem;
    margin-right: 10%;
  }
  .other_margin {
    margin-right: 0.6rem;
  }
  .word_content {
    color: rgba(51, 51, 51, 1);
    line-height: 0.35rem;
    text-align: justify;
  }
  .logo_img {
    width: 2rem;
  }
  .page-index {
    font-size: 0.18rem;
    .pc-img {
      display: block;
    }
    .mobile-img {
      display: none;
    }
    .nav {
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      height: 0.8rem;
      &.sticky {
        background-color: $dark-color;
      }
      .header {
        width: 80%;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        .v2power_logo {
          margin-top: 0.08rem;
        }
        .nav_list {
          padding-top: 0.06rem;
          .nav_name {
            position: relative;
            margin: 0 0.3rem;
            a {
              color: #fff;
            }
            &.active {
              font-weight: bold;
              &::after {
                position: absolute;
                content: "";
                width: 100%;
                height: 0.04rem;
                background: $primary-color;
                bottom: -0.14rem;
                left: 0;
              }
            }
          }
        }
        .contact_us {
          display: flex;
          align-items: center;
          gap: 0.12rem;
          flex-shrink: 0;
          font-size: 0.16rem;
          a {
            display: inline-block;
            padding: 0 0.32rem;
            height: 0.4rem;
            line-height: 0.4rem;
            border-radius: 0.4rem;
            white-space: nowrap;
          }
          .primary-cta {
            background: $primary-color;
            color: #fff;
          }
          .login-btn {
            background: transparent;
            border: 1px solid rgba(255, 255, 255, 0.7);
            color: #fff;
          }
        }
      }
    }
    #home {
      background-color: rgba(0, 133, 80, 0.06);
      width: 100%;
      .home_body {
        max-width: 1920px;
        margin: 0 auto;
        height: 9rem;
        // background-image: url("../assets/img/pc/home-banner1.jpg");
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
        .el-carousel {
          height: 100%;
          overflow: hidden;
          .el-carousel__container {
            height: 100%;
            overflow: hidden;
            .el-carousel__item {
              overflow: hidden;
              &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
              }
            }
            img {
              height: 100%;
              width: 100%;
            }
          }
        }
        .bg-box {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          background-color: rgba(0, 0, 0, 0.3);
        }
        .line-box {
          border-top: 10px solid $primary-color;
          background-color: #fff;
          width: 150%;
          height: 2rem;
          transform: rotate(4deg);
          position: absolute;
          bottom: -1.2rem;
          left: -20%;
          z-index: 2;
        }
        .home_content {
          padding-top: 2rem;
          margin-left: 10%;
          position: absolute;
          z-index: 2;
          height: 100%;
          top: 0;
          left: 0;
          .content_title {
            font-size: 0.48rem;
            line-height: 0.67rem;
          }
          .content_info {
            margin-top: 0.16rem;
            text-align: justify;
            margin-bottom: 0.2rem;
          }
          .go-charging-simulation {
            display: inline-block;
            width: 4.2rem;
            height: 0.68rem;
            line-height: 0.68rem;
            border-radius: 20px;
            text-align: center;
            font-size: 0.24rem;
            margin-top: 1rem;
          }
        }
      }
    }
    .side-public-style {
      padding: 0 2rem;
      margin-top: 0.4rem;
      h5 {
        padding-top: 0.8rem;
      }
    }
    .about-side {
      p {
        color: #333333;
        font-size: 0.24rem;
        font-family: Verdana;
        line-height: 0.36rem;
      }
    }
    .product-side {
      .product-side-content {
        .tip {
          margin-bottom: 0.2rem;
        }
        .product-nav {
          margin-bottom: 0.4rem;
          .product-nav-one {
            flex: 1;
            background-color: rgba(0, 165, 223, 0.04);
            height: 1rem;
            margin-right: 0.1rem;
            border-radius: 0.06rem;
            cursor: pointer;
            padding-right: 0.2rem;
            p {
              font-weight: bold;
            }
            &:last-child {
              margin-right: 0;
            }
            &.active {
              background-color: $primary-color;
              color: #fff;
              position: relative;
              &::after {
                content: "";
                position: absolute;
                left: 50%;
                transform: translate(-50%, 100%);
                bottom: 0;
                width: 0;
                height: 0;
                border-left: 0.2rem solid transparent;
                border-right: 0.2rem solid transparent;
                border-top: 0.2rem solid $primary-color;
                border-bottom: 0.2rem solid transparent;
              }
            }
          }
          img {
            width: 0.4rem;
            margin: 0 0.1rem;
          }
        }
        .el-carousel {
          .el-carousel__indicators {
            text-align: left;
          }
          .el-carousel__container {
            height: 4rem;
          }
          .el-carousel__item {
            height: 4rem;
            h6 {
              font-weight: bold;
              font-size: 0.26rem;
              margin-bottom: 0.4rem;
            }
            p {
              position: relative;
              padding-left: 0.14rem;
              margin-top: 0.2rem;
              i {
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background-color: $primary-color;
                left: 0;
              }
            }
            .text-content {
              max-width: 50%;
              float: left;
            }
            img {
              // width: 7rem;
              max-width: 50%;
              height: 4rem;
              // max-height: 100%;
              flex-shrink: 0;
              float: right;
            }
          }
        }
      }
    }
    .softwares-side {
      padding: 0;
      .software-one {
        display: flex;
      }
      h5 {
        padding-left: 2rem;
      }
      h6 {
        font-weight: bold;
        font-size: 0.24rem;
        margin-bottom: 0.1rem;
      }
      .img-box {
        width: 50%;
        flex-shrink: 0;
        background-color: #f0f9fd;
        text-align: center;
        padding: 0.2rem 0;
        height: 3.4rem;
        &.pc-img {
          display: flex !important;
        }
        img {
          height: 90%;
          max-width: 90%;
          transition: transform 0.4s ease;
          cursor: pointer;
          &:hover {
            transform: scale(1.1);
          }
        }
      }
      .p-r {
        padding-left: 2rem;
        padding-right: 0.4rem;
      }
      .p-l {
        padding-left: 0.4rem;
        padding-right: 2rem;
      }
      .advantage-box {
        position: relative;
        .advantage-content {
          left: 50%;
          width: 40%;
          p {
            color: #fff;
            font-size: 0.24rem;
          }
          a {
            display: inline-block;
            width: 4.2rem;
            height: 0.68rem;
            line-height: 0.68rem;
            background: #fff;
            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
            border-radius: 20px;
            text-align: center;
            color: $primary-color;
            font-size: 0.24rem;
            margin-top: 1rem;
          }
        }
      }
    }
    .partnerships-side {
      padding: 0;
      .partners {
        padding: 0.8rem 2.2rem;
        h5 {
          padding-top: 0;
        }
        .company-logo-list {
          .img-box {
            width: 16%;
            margin-right: 0.8%;
            transition: transform 0.4s ease;
            cursor: pointer;
            &:hover {
              transform: scale(1.1);
            }
            &:nth-child(6n) {
              margin-right: 0;
            }
          }
        }
      }
      .finding-box {
        padding: 0 2rem;
        h5 {
          text-align: center;
        }
        .introduce {
          text-align: center;
          padding: 0 0.2rem;
        }
        .list {
          display: flex;
          justify-content: space-between;
          & > div {
            width: 32%;
            height: 8rem;
            padding: 0 0.2rem;
          }
          .title {
            margin-top: 5rem;
          }
          div {
            position: relative;
            overflow: hidden;
            img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              z-index: 1;
            }
            p {
              position: relative;
              z-index: 2;
            }
          }
        }
      }
    }
    .cases-side {
      .case-list {
        display: flex;
      }
      .malta-system {
        width: 50%;
        flex-shrink: 0;
        overflow: hidden;
        img {
          height: 100%;
          transition: transform 0.4s ease;
          cursor: pointer;
          &:hover {
            transform: scale(1.1);
          }
        }
        p {
          padding-left: 0.2rem;
        }
      }
      .ireland-system-box {
        display: flex;
        flex-wrap: wrap;
        .case-one {
          width: 48%;
          margin-left: 2%;
          &.m-t {
            margin-top: 2%;
          }
          overflow: hidden;
          img {
            transition: transform 0.4s ease;
            cursor: pointer;
            &:hover {
              transform: scale(1.1);
            }
          }
        }
      }
    }
    #contact {
      margin-top: 2rem;
      color: #ffffff;
      padding: 1rem 0;
      .contact_body {
        position: relative;
        .logo {
          width: 2.6rem;
          margin-bottom: 0.2rem;
        }
        .contact_word {
          width: 50%;
          .word_top {
            font-size: 0.2rem;
            font-weight: 400;
            color: #ffffff;
            line-height: 0.28rem;
            text-align: justify;
          }
        }
        .el-form-item {
          margin-bottom: 0.22rem;
        }
        .send_msg {
          width: 6.5rem;
          padding: 0.4rem 0.6rem;
          position: absolute;
          top: -2rem;
          right: 0px;
          .msg_title {
            color: #333333;
            font-weight: 600;
            margin-bottom: 0.3rem;
          }
          .msg_btn {
            margin: 0.3rem 0px 0px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 912px) {
  @import "./media.scss";
}
</style>
